import { Directive, signal } from "@angular/core";

@Directive()
export abstract class ColumnFilters {
  readonly filters = signal<Record<string, any>>({});

  filter(field: string): any {
    return this.filters()[field] ?? "";
  }

  setFilter(field: string, value: any): void {
    this.filters.update((all) => ({ ...all, [field]: value }));
  }

  clearFilters(): void {
    this.filters.set({});
  }
}
